var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAhLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 39.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,15.24c4.14,0,7.5-3.41,7.5-7.62S28.14,0,24,0s-7.5,3.41-7.5,7.62,3.36,7.62,7.5,7.62ZM24,39.63C11.07,39.63.5,29.21,0,16.2c-.02-.52.39-.96.91-.96h9.78c.48,0,.87.38.9.87.44,6.56,5.84,11.77,12.41,11.77s11.97-5.2,12.41-11.77c.03-.49.42-.87.9-.87h9.78c.52,0,.93.44.91.96-.49,13.01-11.07,23.43-24,23.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhLogoMark);
export default __webpack_public_path__ + "static/media/AH-Logo-Mark.e5ccef310981cc268e5de8477be3a7f2.svg";
export { ForwardRef as ReactComponent };